import { fakers } from "@/mocks/faker";
import {
  CreateManagerialUserRequest,
  ListUsersManagerialResponse,
} from "../api/user/users.types";
import { UserRole } from "../types";

const faker = fakers.users;

export const fakeUser = (): ListUsersManagerialResponse => ({
  id: faker.string.uuid(),
  name: faker.person.fullName(),
  email: faker.internet.email(),
  role: faker.helpers.arrayElement(Object.values(UserRole)),
});

export const fakeUsersList = (count = 10): ListUsersManagerialResponse[] =>
  Array.from({ length: count }, fakeUser);

export const fakeCreateUserPayload = (): CreateManagerialUserRequest => ({
  name: faker.person.fullName(),
  email: faker.internet.email(),
  role: faker.helpers.arrayElement(Object.values(UserRole)),
  phone: faker.phone.number(),
  department: faker.helpers.maybe(() => faker.commerce.department()) ?? null,
  position: faker.helpers.maybe(() => faker.person.jobTitle()) ?? null,
});
